<!-- <form (ngSubmit)="submit()">

    <input type="text" [(ngModel)]="otp" name="otp" maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');" pattern="[0-9]+">
    
</form> -->
<form (ngSubmit)="submit()" class="my-4">
  <div class="text-center">
    <h5 class="title">Verify Mobile Number</h5>
    <div class="subtitle-parent">
      <span class="subtitle">We have sent a 4 digit code via SMS to <span class="fw-bold">{{mobileNumber | slice:-10}}</span></span>
      <span>Please enter it here,</span>
      <div id="otp" class="flex justify-center mt-4">
        <input name="text1" [(ngModel)]="text1" class="form-control text-center height_css" type="tel" id="first"
          maxlength="1"  (input)="moveToNext($event, 'second')" (keydown)="handleBackspace($event, '')"
           pattern="[0-9]*" />
        <input name="text2" [(ngModel)]="text2" class="form-control text-center height_css" type="tel" id="second"
          maxlength="1"  (input)="moveToNext($event, 'third')" (keydown)="handleBackspace($event, 'first')"
           pattern="[0-9]*" />
        <input name="text3" [(ngModel)]="text3" class="form-control text-center height_css" type="tel" id="third"
          maxlength="1" (input)="moveToNext($event, 'fourth')" (keydown)="handleBackspace($event, 'second')"
           pattern="[0-9]*" />
        <input name="text4" [(ngModel)]="text4" class="form-control text-center height_css" type="tel" id="fourth"
          maxlength="1" (keydown)="handleBackspace($event, 'third')"
           pattern="[0-9]*" />
      </div>
    </div>
  </div>
  <span class="btn_span_resend my-3 text-start">
    <ng-container class="resend" *ngIf="seconds > 0; else showResend">
      Didn't get the code?({{seconds}} secs)
    </ng-container>
    <ng-template #showResend>
      Didn't get the code?
      <button class="btnbtnb" [disabled]="!canResend" (click)="resend()" type="button">
        <b>Click to resend</b>
      </button>
    </ng-template>
  </span>
  <hr>
  <div class="button-container d-flex justify-content-end gap-3 mt-3">
    <button class="btn cancel-button" type="button" (click)="closeDialog()">Cancel</button>
    <button type="submit" class="btn submit-button" [disabled]="!text1 || !text2 || !text3 || !text4" >{{ submitButtonText }}</button>
  </div>
</form>